import React from 'react';
import "./style.css";
const ShippingPolicy = () => {
    return (
        <div className='Container'>
            <h2>Shipping Policy</h2>
            <div className='privacy'>
                <p>At Ganpati Traders , we aim to provide a seamless shopping experience by ensuring your orders arrive on time and in perfect condition. Below, you'll find all the details about our delivery process so you can shop confidently</p>
                <h4>Shipping Options and Delivery Timelines</h4>
                <p>We offer the following shipping methods to suit your needs:</p>
                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Standard Delivery:</strong> Orders are delivered within 5–7 business days.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Express Delivery:</strong> Receive your order within 2–3 business days. Additional charges may apply.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Same-Day Delivery:</strong> Available for select locations. Please place your order before noon to get it the same day.
                    </li>
                </ul>
                <p>Please note that delivery times are estimates and may vary based on factors like your location, order size, and public holidays.</p>

                <h4>Shipping Charges</h4>
                <p>We offer competitive delivery rates</p>
                <ul id='ulTag'>

                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Free Standard Delivery</strong> On all orders above <strong>₹1,000.</strong>
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        Standard Shipping Fee <strong>₹50</strong> applies to orders below ₹1,000.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        Express Delivery Charges Start at <strong>₹150</strong> and may vary depending on the items or location.
                    </li>
                </ul>

                <h4>Areas of Service</h4>
                <p>We deliver across <strong>India</strong>, covering all major cities, towns, and pin codes. Some remote locations may experience extended delivery times. If you're unsure about delivery to your area, please get in touch with our support team.</p>

                <h4>Order Tracking</h4>
                <p>Stay informed about your order every step of the way! After placing your order, you'll receive a <strong>tracking link</strong> in your confirmation email. You can use this link to monitor your order status in real-time.
                    <br /><br />
                    If you face any issues while tracking your order, feel free to contact our <strong>24/7 customer support team</strong> for assistance.</p>

                <h4>Special Delivery Policies</h4>
                <ul id='ulTag'>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Weather and Other Delays:</strong> Extreme weather or unforeseen circumstances may impact delivery schedules. We'll notify you promptly in case of delays.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        <strong>Cash on Delivery (COD):</strong> We're glad to offer convenient COD options in most locations. COD orders are subject to a small additional fee of ₹30.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        We have 7 days Replacement and exchange policy
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        We have 7 days return policy
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        Replacement and Exchange Product will be Delivered within 7 days.
                    </li>
                    <li style={{ color: '#837f73', fontSize: '18px' }}>
                        Once refund is processed it will be credited in bank account within 5-7 working days
                    </li>
                </ul>

                <h4>Easy Returns and Replacements</h4>
                <p>If you're not satisfied with your order or received a damaged product, don't worry. You can <strong>return or exchange</strong> it within <strong>7 days</strong> of delivery. To initiate a return, visit the <strong>Returns & Refunds</strong> page or contact our support team.</p>
                <h4>Need Help?</h4>
                <p>We're here for you! You can reach our <strong>customer support</strong> anytime by calling <strong>8209393590</strong> or writing to <a style={{ textDecoration: 'none', fontWeight: 'bold', color: 'blue' }} href='mailto:info@ganpatitraders.online'>info@ganpatitraders.online</a>.
                    <br /><br />
                    Thank you for choosing Ganpati Traders for your shopping needs! We're committed to delivering the best products with unmatched convenience.
                    Your delivery information page content is ready! Let me know if there's anything else you'd like to tweak or add.
                </p>
                {/* <ul style={{ textDecoration: 'none', listStyle: 'none' }}>
                    <li style={{ fontSize: '18px' }}><strong>Email:</strong> <a href='mailto:info@ganpatitraders.online'>info@ganpatitraders.online</a></li>
                    <li style={{ fontSize: '18px' }}><strong>Customer Support Center:</strong> Available 24/7 via our website.</li>
                </ul> */}

                <p>Thank you for choosing Ganpati Traders for your shopping needs! Your satisfaction is our priority.</p>
            </div>
        </div>
    )
}

export default ShippingPolicy;